module.exports = __webpack_public_path__ + "images/pro/icon-pro-events-4ac4c2b6e39ecf244a0424323104985f.png";